<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor
                    ref="titileInput"
                    class="titile-input"
                    v-model:valueData="dataList.title"
                    @focus="() => (tipsShow = true)"
                    @blur="() => (tipsShow = false)"
                />
            </div>
            <div class="content">
                <div class="score-box" v-if="dataList.icon === 'Number'">
                    <div class="score-icon" v-for="(item, index) in dataList.score" :key="index">
                        <div
                            class="score-icon_number"
                            :style="{
                                background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                color: index === 0 ? '#fff' : '',
                            }"
                        >
                            {{ item }}
                        </div>
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span>{{ dataList[`score${index + 1}`] }}</span>
                        </div>
                    </div>
                </div>
                <div class="score-box" v-else-if="dataList.icon === 'Ruler'">
                    <div class="score-icon" v-for="(item, index) in dataList.score" :key="index">
                        <div
                            class="score-icon_ruler"
                            :style="{
                                background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                color: index === 0 ? '#fff' : '',
                            }"
                        >
                            {{ item }}
                        </div>
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span>{{ dataList[`score${index + 1}`] }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="score-box">
                    <div class="score-icon" v-for="(item, index) in dataList.score">
                        <img v-if="index === 0" :src="getAssetsImages(dataList.icon + '_light')" />
                        <img v-else :src="getAssetsImages(dataList.icon)" />
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span>{{ dataList[`score${index + 1}`] }}</span>
                        </div>
                    </div>
                </div>
                <!-- 题目聚焦时，出现提示框 -->
                <div v-show="tipsShow" class="title-tips">此题是判断客户整体满意度的重要题目，修改题干请勿偏离“整体满意度”原意。</div>
            </div>

            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                />
            </div>
        </div>
    </div>
</template>
<script setup name="kr-csat">
// js
import { ref, watch, provide } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

import { getAssetsImages } from "@/utils/index";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]); // 复制题目，删除题目, 数据改变, 单题预览;
const titileInput = ref(null);
let tipsShow = ref(false);
watch(
    () => props.dataList,
    (curr, old) => {
        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);

// 可能会在外面改变内部输入框的聚焦情况
defineExpose({ titileInput });
provide("data", props.dataList);
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;
.content {
    .score-box {
        display: flex;
        .score-icon {
            width: 60px;
            min-height: 32px;
            margin-right: 25px;
            display: flex;
            flex-direction: column;
            white-space: nowrap;
            align-items: center;
            img {
                width: 32px;
                height: 32px;
            }
            .score-explain {
                height: 18px;
                margin-top: 10px;
                color: rgba(112, 120, 134, 1);
                font-size: 12px;
                white-space: pre-wrap;
                text-align: center;
            }
        }
        .score-icon_ruler {
            width: 32px;
            height: 32px;
            border: 1px solid rgba(228, 229, 232, 1);
            color: rgba(102, 102, 102, 1);
            line-height: 33px;
            text-align: center;
        }
        .score-icon_number {
            width: 32px;
            height: 32px;
            border: 1px solid rgba(228, 229, 232, 1);
            color: rgba(102, 102, 102, 1);
            border-radius: 50%;
            line-height: 33px;
            text-align: center;
        }
    }
}
</style>
